import * as types from './types';

export const approveDeclineByTimesheetsOrEntriesAsyncRequest = (data) => ({
  type: types.APPROVE_DECLINE_BY_TIMESHEETS_OR_ENTRIES_ASYNC_REQUEST,
  data,
});
export const approveDeclineByTimesheetsOrEntriesRequestFailure = (error) => ({
  type: types.APPROVE_DECLINE_BY_TIMESHEETS_OR_ENTRIES_REQUEST_FAILURE,
  error,
});
export const approveDeclineByTimesheetsOrEntriesRequestSuccess = (data) => ({
  type: types.APPROVE_DECLINE_BY_TIMESHEETS_OR_ENTRIES_REQUEST_SUCCESS,
  data,
});

export const getDoneApprovalsAllRequest = (data) => ({ type: types.GET_DONE_APPROVALS_ALL_REQUEST, data });
export const getDoneApprovalsAllRequestFailure = (error) => ({ type: types.GET_DONE_APPROVALS_ALL_REQUEST_FAILURE, error });
export const getDoneApprovalsAllRequestSuccess = (data) => ({ type: types.GET_DONE_APPROVALS_ALL_REQUEST_SUCCESS, data });

export const getDoneApprovalsAllNextPageRequest = (data) => ({ type: types.GET_DONE_APPROVALS_ALL_NEXT_PAGE_REQUEST, data });
export const getDoneApprovalsAllNextPageRequestFailure = (error) => ({
  type: types.GET_DONE_APPROVALS_ALL_NEXT_PAGE_REQUEST_FAILURE,
  error,
});
export const getDoneApprovalsAllNextPageRequestSuccess = (data) => ({ type: types.GET_DONE_APPROVALS_ALL_NEXT_PAGE_REQUEST_SUCCESS, data });

export const getDoneApprovalsTimesheetRequest = (data) => ({ type: types.GET_DONE_APPROVALS_TIMESHEET_REQUEST, data });
export const getDoneApprovalsTimesheetRequestFailure = (error) => ({ type: types.GET_DONE_APPROVALS_TIMESHEET_REQUEST_FAILURE, error });
export const getDoneApprovalsTimesheetRequestSuccess = (data) => ({ type: types.GET_DONE_APPROVALS_TIMESHEET_REQUEST_SUCCESS, data });

export const getDoneApprovalsTimesheetNextPageRequest = (data) => ({ type: types.GET_DONE_APPROVALS_TIMESHEET_NEXT_PAGE_REQUEST, data });
export const getDoneApprovalsTimesheetNextPageRequestFailure = (error) => ({
  type: types.GET_DONE_APPROVALS_TIMESHEET_NEXT_PAGE_REQUEST_FAILURE,
  error,
});
export const getDoneApprovalsTimesheetNextPageRequestSuccess = (data) => ({
  type: types.GET_DONE_APPROVALS_TIMESHEET_NEXT_PAGE_REQUEST_SUCCESS,
  data,
});

export const getTodoApprovalsGroupsRequest = (data) => ({ type: types.GET_TODO_APPROVALS_GROUPS_REQUEST, data });
export const getTodoApprovalsGroupsRequestFailure = (error) => ({ type: types.GET_TODO_APPROVALS_GROUPS_REQUEST_FAILURE, error });
export const getTodoApprovalsGroupsRequestSuccess = (data) => ({ type: types.GET_TODO_APPROVALS_GROUPS_REQUEST_SUCCESS, data });

export const getTodoApprovalsGroupsNextPageRequest = (data) => ({ type: types.GET_TODO_APPROVALS_GROUPS_NEXT_PAGE_REQUEST, data });
export const getTodoApprovalsGroupsNextPageRequestFailure = (error) => ({
  type: types.GET_TODO_APPROVALS_GROUPS_NEXT_PAGE_REQUEST_FAILURE,
  error,
});
export const getTodoApprovalsGroupsNextPageRequestSuccess = (data) => ({
  type: types.GET_TODO_APPROVALS_GROUPS_NEXT_PAGE_REQUEST_SUCCESS,
  data,
});

export const getTodoApprovalsActiveRequest = (data) => ({ type: types.GET_TODO_APPROVALS_ACTIVE_REQUEST, data });
export const getTodoApprovalsActiveRequestFailure = (error) => ({ type: types.GET_TODO_APPROVALS_ACTIVE_REQUEST_FAILURE, error });
export const getTodoApprovalsActiveRequestSuccess = (data) => ({ type: types.GET_TODO_APPROVALS_ACTIVE_REQUEST_SUCCESS, data });

export const getTodoApprovalsActiveNextPageRequest = (data) => ({ type: types.GET_TODO_APPROVALS_ACTIVE_NEXT_PAGE_REQUEST, data });
export const getTodoApprovalsActiveNextPageRequestFailure = (error) => ({
  type: types.GET_TODO_APPROVALS_ACTIVE_NEXT_PAGE_REQUEST_FAILURE,
  error,
});
export const getTodoApprovalsActiveNextPageRequestSuccess = (data) => ({
  type: types.GET_TODO_APPROVALS_ACTIVE_NEXT_PAGE_REQUEST_SUCCESS,
  data,
});

export const getTodoApprovalsSelectedRequest = (data) => ({ type: types.GET_TODO_APPROVALS_SELECTED_REQUEST, data });
export const getTodoApprovalsSelectedRequestFailure = (error) => ({ type: types.GET_TODO_APPROVALS_SELECTED_REQUEST_FAILURE, error });
export const getTodoApprovalsSelectedRequestSuccess = (data) => ({ type: types.GET_TODO_APPROVALS_SELECTED_REQUEST_SUCCESS, data });

export const getTodoApprovalsSelectedNextPageRequest = (data) => ({ type: types.GET_TODO_APPROVALS_SELECTED_NEXT_PAGE_REQUEST, data });
export const getTodoApprovalsSelectedNextPageRequestFailure = (error) => ({
  type: types.GET_TODO_APPROVALS_SELECTED_NEXT_PAGE_REQUEST_FAILURE,
  error,
});
export const getTodoApprovalsSelectedNextPageRequestSuccess = (data) => ({
  type: types.GET_TODO_APPROVALS_SELECTED_NEXT_PAGE_REQUEST_SUCCESS,
  data,
});
